import {Notifier} from '../notifier'
import {MessageBox} from '../../../components/message-box'
import {Notifications} from '../../../../common/notifications'

export const browserInitNotifier = () => {
  Notifier.init(MessageBox.show, Notifications.notify, Notifications.ring)
}
